import type { Formula, VehicleColor } from '@otw/models'
import type { OLSModelVersion } from '@otw/models/ols'
import { calculatePrice } from 'hooks/graybook/useFormula'

export interface ResolveGrayBookPriceParams {
  year: number
  mileage: number
  color: VehicleColor
  formula: Formula
  formulasWithRules: Formula[]
  olsVersion?: OLSModelVersion | null
}

export interface ResolvedPrice {
  price: number
  method: string
}

export function resolveGrayBookPrice({
  year,
  mileage,
  color,
  formula,
  formulasWithRules,
  olsVersion,
}: ResolveGrayBookPriceParams): ResolvedPrice {
  if (olsVersion) {
    const { coefficients, minBound, maxBound } = olsVersion.sellModel
    const isDiesel = formula.vehicleFuel === 'Diesel' ? 1 : 0
    const isWhite = color === 'White' ? 1 : 0
    let price =
      (coefficients.intercept ?? 0) +
      year * (coefficients.year ?? 0) +
      (mileage / 1000) * (coefficients.mileage ?? 0) +
      isWhite * (coefficients.isWhite ?? 0) +
      isDiesel * (coefficients.isDiesel ?? 0) +
      isDiesel * year * (coefficients.yearDieselInteraction ?? 0) +
      isDiesel * (mileage / 1000) * (coefficients.mileageDieselInteraction ?? 0)
    price = Math.min(Math.max(price, minBound), maxBound)
    return { price: Math.round(price), method: 'OLS Model' }
  }

  const formulaWithRules = formulasWithRules.find(f => f.id === formula.id)
  const rules = formulaWithRules?.rules || []
  const { price } = calculatePrice({ input: { year, mileage }, formula, rules })
  return { price, method: 'Formula Rules' }
}
